<template>
  <el-dialog
    v-if="dialog"
    :title="type === 'edit'?'编辑':'新增'"
    :visible.sync="dialog"
    :width="getIsMobile?'100%':'50%'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form ref="formRef" :model="form" label-width="90px" :label-position="getIsMobile?'top':'right'" :rules="rules" class="custom-form">
      <el-form-item label="账号" prop="username">
        <el-input v-model="form.username" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="form.password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="rname">
        <el-input v-model="form.rname" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="QQ" prop="qq">
        <el-input v-model="form.qq" placeholder="请输入QQ号"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="tel">
        <el-input v-model="form.tel" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="编号" prop="num">
        <el-input v-model="form.num" placeholder="请输入编号"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleReset">重 置</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, ref, watch } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting';
export default defineComponent({
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(props,{emit}) {
    const {getIsMobile} = useRootSetting()
    const formRef = ref(null)
    const rules = {
      username: [
        { required: true, message: '账号不能为空', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '密码不能为空', trigger: 'blur' },
        { min: 6, max: 12, message: '密码长度必须在6到12位之间', trigger: 'blur' }
      ],
      rname: [
        { required: true, message: '姓名不能为空', trigger: 'blur' }
      ],
      qq: [
        { required: true, message: 'QQ号不能为空', trigger: 'blur' }
      ],
      tel: [
        { required: true, message: '联系电话不能为空', trigger: 'blur' }
      ],
      num: [
        { required: true, message: '编号不能为空', trigger: 'blur' }
      ],
    }

    const radio = ref(1)
    const defaultForm = () => (
      {
        username: '',
        password:'',
        rname:'',
        qq:'',
        tel:'',
        num:''
      }
    )
    const form = reactive(defaultForm())

    watch(()=> props.formData, (val)=> {
      if (!val || typeof val !== 'object') return;
      Object.keys(val).forEach((key) => {
        if (key in form) {
          const value = val[key];

          // 判断 value 是否为字符串形式的纯数字
          form[key] = typeof value === 'string' && !isNaN(value)
            ? Number(value)
            : value;
        }
      });
    },{deep:true})

    const handleReset = () => {
      formRef.value.resetFields()
      Object.assign(form, defaultForm())
    }

    const handleSubmit = () => {
        formRef.value.validate(valid => {
        if (valid) {
          emit('submit', form)
        }
      })
    }

    const handleClose = () => {
      emit('close')
      handleReset()
    }


    return {
      getIsMobile,
      formRef,
      form,
      rules,
      radio,
      handleReset,
      handleSubmit,
      handleClose
    }
  }
})
</script>
